import { Compass, PenTool, Code2, Rocket } from "lucide-react";
import Reveal from "./Reveal.jsx";

const STEPS = [
  {
    icon: Compass,
    label: "01 · Upptäcka",
    title: "Kartläggning",
    desc: "Vi förstår dina mål, målgrupp och affär — så att designen blir mer än vacker.",
  },
  {
    icon: PenTool,
    label: "02 · Design",
    title: "Konceptdesign",
    desc: "Skiss, prototyp och visuell riktning som vi finjusterar tillsammans.",
  },
  {
    icon: Code2,
    label: "03 · Utveckling",
    title: "Byggfas",
    desc: "Produktionsklar kod i React med fokus på prestanda, SEO och tillgänglighet.",
  },
  {
    icon: Rocket,
    label: "04 · Lansering",
    title: "Launch & drift",
    desc: "Vi släpper, mäter och optimerar — och finns kvar som långsiktig partner.",
  },
];

export default function Process() {
  return (
    <section className="relative bg-sand-50 py-24 sm:py-32">
      <div className="container-x">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="eyebrow">
                <span className="h-1.5 w-1.5 rounded-full bg-leather" />
                Så jobbar vi
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="section-title mt-5">
                En process byggd för att <em className="not-italic text-leather">flyta.</em>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-7">
            <p className="text-lg leading-relaxed text-navy-700">
              Vi blandar designhantverk med AI-stöd för att leverera fyra gånger
              snabbare än traditionella byråer — utan att tumma på kvaliteten.
              Du har en fast kontaktperson genom hela resan.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={0.06 * i}>
                <div className="relative h-full rounded-3xl border border-navy-900/8 bg-white p-7 shadow-soft">
                  <div className="absolute -top-4 right-6 grid h-9 w-9 place-items-center rounded-full bg-navy-900 text-sand-200">
                    <Icon className="h-4 w-4" />
                  </div>
                  <p className="text-xs font-semibold uppercase tracking-[0.18em] text-leather">
                    {s.label}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-semibold text-navy-900">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-700">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
